<div [dir]="Direction">
  <app-header />
  <app-hero />
  <app-categories />
  <app-newarrived />
  <!-- <app-clients /> -->
  <app-footer />
</div>
